import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    routeId: Number
  }

  connect() {
    this.checkStatus()
  }

  async checkStatus() {
    try {
      const response = await fetch(`/able_link_routes/${this.routeIdValue}/status`, {
        headers: {
          "Accept": "application/json"
        }
      })

      if (!response.ok) {
        console.error("Failed to check route status")
        return
      }

      const data = await response.json()

      if (data.route_available) {
        // Refresh the Turbo Frame to show updated route status
        const frame = this.element.closest("turbo-frame")
        frame.reload()
      }
    } catch (error) {
      console.error("Error checking route status:", error)
    }
  }
}
